import { createContext, useState, useCallback, useEffect, useContext } from 'react'
import authService from 'api/auth-service'
import { usePermissions } from 'react-admin'

export const UserContext = createContext(null)

export const useUser = () => useContext(UserContext)

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null)
    const [isLoadUser, setIsLoadUser] = useState(false)
    const { permissions: rightPermissions } = usePermissions()

    const getUser = useCallback(async () => {
        try {
            const data = await authService.getMe()
            if (data) {
                setUser(data)
            }
            setIsLoadUser(true)
        } catch (error) {
            console.error('Get User Error:', error)
        }
    }, [])

    useEffect(() => {
        if (rightPermissions && !isLoadUser && !user) {
            getUser()
        }
    }, [rightPermissions, isLoadUser, user, getUser])

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    )
}